import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });
export const INSTAGRAM = "https://www.instagram.com/tbrand_111?xtok=aXY4dm14eXpsYjNn";
export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};
